import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11d132a0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=11d132a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.5.3_vue-template-_f4dofbnduhzujdqtfjqykoctku/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d132a0",
  null
  
)

export default component.exports